module.exports = __webpack_public_path__ + "img/white.a085538.svg";